import React from "react";

const IconChecksSvg = ({ size = 16 }: { size?: number }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden
	>
		<path d="M1.33333 8.33333L4.33333 11.3333L10 5.33333" />
		<path d="M7.33333 10.6667L8 11.3333L13.6667 5.33333" />
	</svg>
);

export default IconChecksSvg;
